// Global Game Constants - Now loaded from centralized configuration
// This file provides backward compatibility for existing code

import { DevConfig } from '../config/environment/devConfig';
import { ENTITY_CONFIG } from './constants/EntityConfig'; // NEW: Centralized Entity Data
import { GAMEPLAY_CONFIG } from './constants/GameplayConfig';
import { GRID_CONSTANTS } from './constants/GridConstants';
import { NETWORK_CONFIG } from './constants/NetworkConfig';
import { NPC_DEFAULTS } from './constants/NPCConfig'; // Global defaults
import { PHYSICS_CONFIG } from './constants/PhysicsConfig';
import { UI_CONFIG } from './constants/UIConfig';

export const GameConstants = {
  get Network() { return NETWORK_CONFIG; },
  get Physics() {
    return {
      GRAVITY: PHYSICS_CONFIG.GRAVITY.DEFAULT,
      TERMINAL_VELOCITY: PHYSICS_CONFIG.GRAVITY.TERMINAL_VELOCITY,
      AIR_FRICTION: PHYSICS_CONFIG.GRAVITY.AIR_FRICTION,
      MAX_FALL_SPEED: PHYSICS_CONFIG.GRAVITY.MAX_FALL_SPEED,
      COYOTE_TIME: PHYSICS_CONFIG.MOVEMENT.COYOTE_TIME,
      JUMP_BUFFER_TIME: PHYSICS_CONFIG.MOVEMENT.JUMP_BUFFER,
      CORNER_NUDGE_THRESHOLD: PHYSICS_CONFIG.MOVEMENT.CORNER_NUDGE,
      FALLING_GRAVITY_MULTIPLIER: PHYSICS_CONFIG.GRAVITY.FALLING_MULTIPLIER,
      // Logic constants
      GROUND_SNAP_OFFSET_Y: PHYSICS_CONFIG.LOGIC.GROUND_SNAP_OFFSET_Y,
      GROUND_SNAP_BUFFER: PHYSICS_CONFIG.LOGIC.GROUND_SNAP_BUFFER,
      MAX_PLATFORM_SEARCH_DISTANCE: PHYSICS_CONFIG.LOGIC.MAX_PLATFORM_SEARCH_DISTANCE
    };
  },
  get Gameplay() {
    return {
      RESPAWN_DELAY: GAMEPLAY_CONFIG.respawnDelay,
      I_FRAME_DURATION: GAMEPLAY_CONFIG.iFrameDuration,
      LOOT_VACUUM_RANGE: 150,
      loot: GAMEPLAY_CONFIG.loot
    };
  },
  get Combat() {
    return {
      GCD_DURATION: GAMEPLAY_CONFIG.gcdDuration,
      ATTACK_RANGE_MELEE: GAMEPLAY_CONFIG.attackRangeMelee,
      ATTACK_RANGE_RANGED: GAMEPLAY_CONFIG.attackRangeRanged,
      KNOCKBACK_FORCE_X: GAMEPLAY_CONFIG.knockbackForceX,
      KNOCKBACK_FORCE_Y: GAMEPLAY_CONFIG.knockbackForceY,
      HOMING_STRENGTH_BASIC: 4,
      HOMING_STRENGTH_SPECIAL: 8,
      HOMING_MAX_TURN_RATE: 200,
      HOMING_DELAY_BASIC: 50,
      HOMING_DELAY_SPECIAL: 100,
      PROJECTILE_LIFESPAN: 1500,
      TARGETING_MAX_RANGE: GAMEPLAY_CONFIG.targeting.maxRange,
      TARGETING_TAB_CYCLE_WINDOW_MS: GAMEPLAY_CONFIG.targeting.tabCycleWindowMs
    };
  },
  get Persistence() {
    return {
      MAX_SAVE_SLOTS: GAMEPLAY_CONFIG.persistence.maxSaveSlots,
      SAVE_VERSION: GAMEPLAY_CONFIG.persistence.saveVersion,
      SAVE_KEY: GAMEPLAY_CONFIG.persistence.saveKey
    };
  },
  Dev: {
    SHOW_HITBOXES: false,
    get SKIP_LOGIN() { return DevConfig.skipLogin; },
  },
  Grid: {
    TILE_SIZE: GRID_CONSTANTS.TILE_SIZE,
  },
  get UI() { return UI_CONFIG; },
  get NPC() { return NPC_DEFAULTS; },
  get Entities() { return ENTITY_CONFIG; }, // Expose new entity data
  get Defaults() {
    return {
      // Canonical no-context fallback map (SSOT). The deep fallback when no
      // ?map / preset / saved position resolves — server room
      // (GameRoomLifecycle) + the client GameConstants proxy + BootService.
      // 'starter-map' is the guaranteed-loadable, always-registered base and is
      // also MapSystem.loadLevel's hard fallback, so every fallback path agrees.
      // (Was split: 'pig-testring' here vs 'multiplayer-observe' in the client
      // proxy — collapsed 2026-06-05.)
      MAP: 'starter-map',
      SPAWN_POS: { x: 400, y: 300 },
    };
  }
};
